<template>
	<div class="main" style="background-color: #fff;padding-bottom: 100px;">
		<hwk-header></hwk-header>
		<div class="warp" v-if="goods && goods.id">
			<div class="back pointer" @click="goBack">
				<i class="el-icon-arrow-left"></i><span>商品详情</span>
			</div>
			<div class="img-con">

				<div class="l-img">

					<div class="t">
						<!-- <img :src="http + bimg" alt="" /> -->

						<video :src="http + bimg" v-if="isMp4(bimg)" autoplay muted controls></video>

						<el-image style="width: 100%; height: 100%" :src="http + bimg" :preview-src-list="srcList"
							v-else>
						</el-image>
						<div class="btn left" @click="changeImg('left')"><i class="el-icon-arrow-left"></i></div>
						<div class="btn right" @click="changeImg('right')"><i class="el-icon-arrow-right"></i></div>
					</div>
					<!-- <div class="imgs">
						<div class="btn left"><i class="el-icon-arrow-left"></i></div>
						<div class="btn right"><i class="el-icon-arrow-right"></i></div>
						<div class="b">
							<div class="i" :class="{on:imgIndex==index}" v-for="(item,index) in images" :key="index"
								@click="changeImg2(index)">
								<img :src="http + item" alt="" />
							</div>
						</div>
					</div> -->
					<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide pointer" :class="{on:imgIndex==index}"
								v-for="(item, index) in images" :key="index" @click="changeImg2(index)">
								<video :src="http + item" v-if="isMp4(item)"></video>
								<img :src="http + item" alt="" v-else />
								<img src="@/assets/play.png" alt="" v-if="isMp4(item)" class="play" />
							</div>
						</div>
						<!-- <div class="swiper-pagination"></div> -->
						<div class="swiper-button swiper-button-prev" @click="changeImg('left')"></div>
						<div class="swiper-button swiper-button-next" @click="changeImg('right')"></div>
					</div>

				</div>
				<div class="r-con" v-if="rshow == false">
					<div class="title">{{goods.title}}</div>
					<div class="p-s flex">
						<div class="p">价格￥<span><b class="num-din">{{price}}</b></span></div>
						<div class="s">已售<span>{{sales_number}}</span></div>
					</div>
					<!-- :class="{not:number==0}" -->
					<div class="f-list">
						<template v-if="goods.type==1">
							<div class="item flex" v-for="(item,index) in sku_data" :key="index">
								<div class="title">{{item.goods_attr_title}}</div>
								<div class="slist flex">
									<div class="i pointer" :class="{on:skulist[index]==item2.id}"
										v-for="(item2,index2) in item.goods_attr_spec_arr" :key="index2"
										@click="changesku(index,item2.id)">
										{{item2.name}}
									</div>
								</div>
							</div>
						</template>
						<!-- 53, 55, 58, 65 -->
						<template v-else>
							<div class="item flex">
								<div class="title">商品</div>
								<div class="slist flex">
									<div class="i pointer" :class="{on:cid==item.id}"
										v-for="(item,index) in goods_childs" :key="index"
										@click="changesku2(index,item.id)">
										{{item.sku_string}}
									</div>
								</div>
							</div>
						</template>
						<div class="item flex">
							<div class="title">仓库</div>
							<div class="slist flex">
								<div class="i pointer" :class="{on:wid==item.id}" v-for="(item,index) in wlist"
									:key="index" @click="changewh(item.id,index)">{{item.name}}</div>
							</div>
						</div>
						<div class="item flex" style="margin-top: 20px;">
							<div class="title">数量</div>
							<div class="slist2 flex">
								<div class="n"> <el-input-number v-model="pay_number" @change="handleChange" :min="1"
										:max="number" label="描述文字"></el-input-number></div>
								<div class="m" v-if="number>0">有货 <span>{{number}}</span></div>
								<div class="m" v-else>库存不足</div>
							</div>
						</div>
					</div>
					<div class="btns flex" v-if="number>0">
						<div class="btn btn1" @click="buyGoods">立即购买</div>
						<div class="btn btn2" @click="addCart">加入购物车</div>
					</div>
				</div>
			</div>
		</div>

		<div class="middle" ref="middle">
			<div class="warp m-list flex">
				<div class="item pointer" :class="{on:mindx==0}" @click="mChange(0)">参数信息</div>
				<div class="item pointer" :class="{on:mindx==1}" @click="mChange(1)">商品详情</div>
				<div class="item pointer" :class="{on:mindx==2}" @click="mChange(2)">素材下载</div>
			</div>
		</div>
		<div class="warp">
			<div class="g-body" ref="gbody1">
				<div class="title">
					参数信息
				</div>
				<div class="table">
					<el-descriptions class="margin-top" title="" :column="2" size="medium" border>

						<el-descriptions-item v-for="(item,index) in parameter_json" :key="index"
							label-class-name="my-label" content-class-name="my-content" :label="item.label">

							{{item.value}}
						</el-descriptions-item>

					</el-descriptions>
				</div>
			</div>
			<div class="g-body" ref="gbody2">
				<div class="title">
					商品详情
				</div>

				<div class="body" id="good-body" v-html="goods_info.content"></div>
			</div>
			<div class="g-body" ref="gbody3">
				<div class="title">
					素材下载<span>（含以上商品详情的所有图片）</span>
				</div>
				<div class="body2">
					<div class="item pointer flex" v-for="(item,index) in files" :key="index" @click="downLoad(index)">
						<div class="l flex">
							<img src="@/assets/rar.png" alt="" />
							<div class="con">
								<div class="t">{{goods.title}}-详情素材包({{index +1}}).zip</div>
								<div class="p">更新时间:{{$timeFormat(goods.updatetime,'yyyy-mm-dd')}}</div>
							</div>
						</div>
						<div class="r">下载</div>
					</div>
				</div>
			</div>
		</div>
		<div class="right-float" v-show="rshow">
			<div class="img-c">
				<img :src="http + goods.image" alt="" />
				<div class="c">
					<div class="p">价格￥<span><b class="num-din">{{price}}</b></span></div>
					<div class="n">已售<span>{{sales_number}}</span></div>
				</div>
			</div>
			<!-- :class="{not:number==0}" -->
			<div class="f-list">
				<template v-if="goods.type==1">
					<div class="item flex" v-for="(item,index) in sku_data" :key="index">
						<div class="title">{{item.goods_attr_title}}</div>
						<div class="slist flex">
							<div class="i pointer" :class="{on:skulist[index]==item2.id}"
								v-for="(item2,index2) in item.goods_attr_spec_arr" :key="index2"
								@click="changesku(index,item2.id)">
								{{item2.name}}
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="item flex">
						<div class="title">商品</div>
						<div class="slist flex">
							<div class="i pointer" :class="{on:cid==item.id}" v-for="(item,index) in goods_childs"
								:key="index" @click="changesku2(index,item.id)">
								{{item.sku_string}}
							</div>
						</div>
					</div>
				</template>

				<div class="item flex">
					<div class="title">仓库</div>
					<div class="slist flex">
						<div class="i pointer" :class="{on:wid==item.id}" v-for="(item,index) in wlist" :key="index"
							@click="changewh(item.id,index)">{{item.name}}</div>
					</div>
				</div>
				<div class="item flex" style="margin-top: 20px;">
					<div class="title">数量</div>
					<div class="slist2 flex">
						<div class="n"> <el-input-number v-model="pay_number" @change="handleChange" :min="1"
								:max="number" label="描述文字"></el-input-number></div>
						<div class="m" v-if="number>0">有货 <span>{{number}}</span></div>
						<div class="m" v-else>库存不足</div>
					</div>
				</div>
			</div>
			<div class="btns flex" v-if="number>0">
				<div class="btn btn1" @click="buyGoods">立即购买</div>
				<div class="btn btn2" @click="addCart">加入购物车</div>
			</div>
		</div>
		<el-dialog title="" :visible.sync="dialogVisible" width="220px" :show-close="false">
			<div class="hwk-dialog">
				<img src="@/assets/logo.png" alt="" />
				<p>成功加入购物车</p>
				<div class="btn pointer" @click="pageTo('car')">去购物车</div>
			</div>
		</el-dialog>
		<navigation :cartshow="true"></navigation>




	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import Swiper from 'swiper';
	import 'swiper/swiper-bundle.css';

	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation,
			Swiper,


		},
		data() {
			return {

				slides: ['Slide 1', 'Slide 2', 'Slide 3'],
				imgIndex: 0,
				pay_number: 1,
				http: this.$imgUrl,
				dialogVisible: false,
				rshow: false,
				body: '1123',
				mindx: 0,
				num: 1,
				height: 0,
				scrollDistance: 0,
				id: '',
				goods: {
					id: ''
				},
				goods_info: {},
				img: "",
				images: [],
				sku_data: [],
				wlist: [],
				skulist: [],
				slist: [],
				wid: 0,
				price: 0,
				sales_number: 0,
				number: 0,
				cid: 0,
				goods_child: {},
				warehouse: {},
				bimg: '',
				parameter_json: [],
				files: [],
				srcList: [],
				attr_data_json: [],
				goods_childs: [],
				pjskuid: -1,
				warehouse_inventory_ids: [],
				default_child_data: {}
			}
		},
		created() {
			this.id = this.$route.query.id
			this.getData()
			console.log(this.userinfo.is_attestation)
		},
		computed: {
			...mapState(['userinfo']),
			isMp4() {
				return (url) => {
					return url && typeof url === 'string' && url.endsWith('.mp4');
				}
			},
		},
		mounted() {

			this.height = this.$refs.middle.getBoundingClientRect().top + window.scrollY;
			console.log(this.height, 'this.height')
			window.addEventListener('wheel', this.handleScroll);

			setTimeout(() => {
				// 初始化 Swiper
				new Swiper('.swiper-container', {
					// 分页器配置
					// pagination: {
					// 	el: '.swiper-pagination'
					// },
					slidesPerView: 6,
					spaceBetween: 10,
					slidesPerGroup: 6,
					// 导航按钮配置
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				});
			}, 1000)

		},
		beforeDestroy() {
			// 确保在组件销毁前移除事件监听器，避免内存泄漏
			window.removeEventListener('wheel', this.handleScroll);
		},

		methods: {


			async downLoad(index) {
				if (this.userinfo.is_attestation == 0) {
					this.$message({
						message: '您的账号暂未认证，暂不能下载，请先通过账号认证，谢谢!',
						type: 'warning'
					});
					return
				}




				let zipUrl = this.http + this.files[index]
				try {
					// 设置 responseType 为 blob，以便处理二进制数据
					const response = await this.$http.get(zipUrl, {
						responseType: 'blob'
					});

					// 创建一个临时的 <a> 元素用于下载
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;

					// 获取文件名（可选），默认命名为 archive.zip
					let filename = `${this.goods.title}-详情素材包(${index+1}).zip`;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
					link.remove(); // 下载完成后移除
					window.URL.revokeObjectURL(url); // 释放内存
				} catch (error) {
					console.error('下载失败:', error);
					alert('下载失败，请重试');
				}
			},
			changeImg2(index) {
				if (this.imgIndex != index) {
					this.imgIndex = index
					this.bimg = this.images[this.imgIndex]
				}
			},
			changeImg(type) {
				if (type == 'left') {
					if (this.imgIndex == 0) {
						this.imgIndex = this.images.length - 1
					} else {
						this.imgIndex--
					}

				} else {
					if (this.imgIndex == this.images.length - 1) {
						this.imgIndex = 0
					} else {
						this.imgIndex++
					}
				}
				this.bimg = this.images[this.imgIndex]
			},
			buyGoods() {
				if (this.userinfo.is_attestation == 0) {
					this.$message.error('您的账号暂未认证，请认证后再下单');
					return
				}
				this.goods_child.price = this.price
				this.goods_child.out_price = this.price
				let list = [{
					id: 0,
					createtime: parseInt(new Date().getTime() / 1000),
					deletetime: null,
					goods: {
						id: this.id,
						title: this.goods.title,
						image: this.goods.image,
						out_price: this.goods_child.out_price,
						price: this.price,
					},
					goods_child: this.goods_child,
					goods_child_id: this.cid,
					goods_id: this.id,
					pay_number: this.pay_number,
					updatetime: parseInt(new Date().getTime() / 1000),
					user_id: localStorage.getItem('userId'),
					warehouse: this.warehouse,
					warehouse_id: this.wid
				}]
				localStorage.setItem('myPayCart', JSON.stringify(list));
				this.$router.push({
					path: "/carAddress",
					query: {
						from: 'goods'
					}
				});

			},
			addCart() {
				if (this.userinfo.is_attestation == 0) {
					this.$message.error('您的账号暂未认证，请认证后再下单');
					return
				}
				if (this.wid == 0) {
					this.$message({
						message: '请选择仓库',
						type: 'warning'
					});
					return
				}
				if (this.cid == 0) {
					this.$message({
						message: '请选择规格',
						type: 'warning'
					});
					return
				}
				if (this.number == 0) {
					this.$message({
						message: '暂无库存',
						type: 'warning'
					});
					return
				}
				if (this.pay_number > this.number) {
					this.$message({
						message: '库存不足',
						type: 'warning'
					});
					return
				}
				console.log(this.cid, this.wid, this.pay_number)
				this.$http.post('/api/user_car/add_edit', {
					goods_child_id: this.cid,
					warehouse_id: this.wid,
					pay_number: this.pay_number

				}).then(res => {
					if (res.code == 1) {
						this.$message({
							type: 'success',
							message: '添加成功!'
						});
						this.getCart()
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				});
			},
			getCart() {
				this.$http.get('/api/user_car/index', {

				}).then(res => {
					console.log(222222)
					let number = res.data.data.length
					console.log(number, 'number')
					localStorage.setItem('cartNumber', number);
					this.$store.dispatch('setCartNumber', number);

				});
			},
			changewh(id, index) {
				if (this.wid != id) {
					this.wid = id
					this.warehouse = this.wlist[index]
					this.getPrice()
				}
			},
			// 配件选规格
			changesku2(index, id) {
				this.cid = id
				// this.price = this.goods_childs[index].price
				this.goods_child = this.goods_childs[index]
				this.getPrice()
			},

			changesku(index, id) {
				console.log(index, id)
				this.skulist[index] = id
				console.log(this.skulist, 'this.skulist')
				// let findex = this.slist.findIndex(item => item.sku_ids == this.skulist.toString())
				// if (findex > -1) {
				// 	this.price = this.slist[findex].price
				// 	this.cid = this.slist[findex].id
				// 	this.goods_child = this.slist[findex]
				// 	this.notHave = false
				// } else {
				// 	this.notHave = true
				// }
				let ss = this.goods_childs.map(item => item.sku_ids)
				let findex2 = this.goods_childs.findIndex(item => item.sku_ids == this.skulist.toString())
				if (findex2 > -1) {
					// this.price = localStorage.getItem('userAttest') == 0 ? this.goods_childs[findex2].out_price : this.goods_childs[findex2].price
					this.cid = this.goods_childs[findex2].id
					this.goods_child = this.goods_childs[findex2]
				}
				this.getPrice()
				this.$forceUpdate()
			},
			getPrice() {
				this.$http.get('/api/goods/goods_child_warehouse', {
					params: {
						goods_child_id: this.cid,
						warehouse_id: this.wid,
					}
				}).then(res => {
					if (res.code == 1 && res.data) {
						this.number = res.data.number
						this.price = res.data.price
					} else {
						this.number = 0
						this.price = 0
					}
				});
			},
			getnavlist() {

				this.$http.get('/api/goods/goods_option', {

				}).then(res => {
					// let sku_data = res.data.sku_data
					// sku_data.forEach(item => {
					// 	item.uid = 0
					// })
					// sku_data.forEach(item => {
					// 	item.attr_spec.forEach(item2 => {
					// 		this.slist.forEach(item3 => {
					// 			let list = item3.sku_ids.split(',')
					// 			item2.has = list.includes(item2.id.toString())
					// 		})
					// 	})
					// })

					// this.sku_data = sku_data.filter(item => item.attr_spec.some(item2 => item2.has))
					// this.skulist = this.sku_data.map(item => item.attr_spec[0].id)
					// let index = this.slist.findIndex(item => item.sku_ids == this.skulist.toString())
					// console.log(index, 'index')
					// if (index > -1) {
					// 	this.price = this.slist[index].price
					// 	this.sales_number = this.slist[index].sales_number
					// 	this.number = this.slist[index].number
					// 	this.cid = this.slist[index].id
					// 	this.goods_child = this.slist[index]
					// }

					// this.wlist = res.data.warehouse_data

					if (this.warehouse_inventory_ids.length > 0) {
						let list = res.data.warehouse_data
						this.wlist = list.filter(item => this.warehouse_inventory_ids.includes(item.id));
					}
					let index = this.wlist.findIndex(item => item.id == this.wid)
					this.warehouse = this.wlist[index]
					// this.wid = this.wlist[0].id
					this.getPrice()
				});
			},
			getData() {
				this.$http.get('/api/goods/info', {
					params: {
						id: this.id
					}

				}).then(res => {
					this.goods = res.data.goods
					// this.price = localStorage.getItem('userAttest') == 0 ? res.data.goods.out_price : res.data
					// 	.goods.price
					this.sales_number = res.data.goods.sales_number
					this.goods_info = res.data.goods_info
					this.images = res.data.goods_info.images ? res.data.goods_info.images.split(',') : [];
					this.srcList = this.images.map(item => this.http + item)
					this.img = res.data.goods.image
					this.bimg = this.images[0]
					this.warehouse_inventory_ids = res.data.warehouse_inventory_ids
					// this.slist.forEach(item => item.number = Math.floor(Math.random() * 100) + 1)

					this.goods_childs = res.data.goods_child

					let parameter_json = res.data.goods_info.parameter_json && JSON.parse(res.data.goods_info
						.parameter_json)
					for (let key in parameter_json) {
						this.parameter_json.push({
							label: key,
							value: parameter_json[key]
						})
					}
					this.files = res.data.goods_info.files ? res.data.goods_info.files.split(',') : [];
					if (res.data.goods_info.sku_data_json) {
						let data = res.data.goods_info.sku_data_json
						this.slist = JSON.parse(data)
					}
					this.default_child_data = res.data.default_child_data
					this.wid = this.default_child_data.warehouse_id
					this.cid = this.default_child_data.goods_child_id

					let indexDef = this.goods_childs.findIndex(item => item.id == this
						.default_child_data.goods_child_id)
					this.goods_child = indexDef > -1 ? this.goods_childs[indexDef] : {}
					console.log(this.default_child_data, this.wid, this.cid, indexDef, '--------indexDef--------')
					// this.price = this.default_child_data.price
					// this.number = this.default_child_data.number

					if (this.goods.type == 1) {
						if (res.data.goods_info.attr_data_json) {
							this.attr_data_json = res.data.goods_info.attr_data_json && JSON.parse(res.data
								.goods_info
								.attr_data_json)
							this.sku_data = this.attr_data_json.filter(item => item.goods_attr_spec_arr.length > 0)
							console.log(this.sku_data, '-----this.sku_data------')
							if (indexDef > -1) {
								let sku_ids = this.goods_childs[indexDef].sku_ids
								this.skulist = sku_ids.split(',').map(item => parseInt(item))
							}
						}
					}
					this.getnavlist();
				});
			},

			goBack() {
				this.$router.go(-1);
			},
			pageTo(url) {
				this.dialogVisible = false
				this.$router.push({
					path: url,
				});
			},
			open() {
				this.$confirm('认证通过后才可以下载资料', '认证提示', {
					confirmButtonText: '去认证',
					cancelButtonText: '取消',
					// type: 'warning',
					// center: true,
					confirmButtonClass: "confirmButtonClass"
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

			handleScroll(event) {
				console.log(event, `滚动方向：${event.deltaY > 0 ? '向下' : '向上'}`);
				this.scrollDistance += event.deltaY;
				console.log(this.scrollDistance)
				this.rshow = this.scrollDistance > this.height
				// 你可以在这里根据滚动的方向执行相应的操作
				if (event.deltaY > 0) {
					// 向下滚动时的操作
				} else {
					// 向上滚动时的操作
				}
			},
			mChange(i) {
				this.mindx = i
				console.log(this.mindx)
				this.scrollToSection(i)
			},
			scrollToSection(i) {
				let target = null
				if (i == 0) {
					target = this.$refs.gbody1;
				} else if (i == 1) {
					target = this.$refs.gbody2;
				} else {
					target = this.$refs.gbody3;
				}
				const offsetTop = target.offsetTop;

				window.scrollTo({
					top: offsetTop - 100,
					behavior: 'smooth'
				});
			},
			handleChange(value) {
				console.log(value);
			},
		},
	};
</script>
<style lang="less" scoped>
	@color: #FF6A00;
	@color1: #11192D;



	.swiper-container {
		width: 100%;
		height: 100px;
		position: relative;
		overflow: hidden;

		.swiper-button {
			background: #333;
			color: #fff;
			width: 36px;
			height: 36px;
			border-radius: 50%;
			overflow: hidden;

			&::after {
				font-size: 14px;
			}
		}

		.swiper-button-prev {
			z-index: 999;

		}

		.swiper-button-next {
			z-index: 999;
		}

		.swiper-wrapper {
			width: 100%;
			height: 100%;

			.swiper-slide {
				width: 94px;
				height: 94px;
				border-radius: 4px;
				overflow: hidden;
				border: 1px solid #D9D9D9;
				position: relative;

				img,
				video {
					width: 100%;
					height: 100%;
				}

				.play {
					position: absolute;
					width: 40px;
					height: 40px;
					left: 50%;
					top: 50%;
					margin-left: -20px;
					margin-top: -20px;

				}
			}

			.on {
				border: 1px solid @color;
			}
		}
	}

	.hwk-dialog {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;

		img {
			width: 53px;
			height: 53px;
		}

		p {
			line-height: 30px;
			height: 30px;
			font-weight: 500;
			font-size: 16px;
			color: #000000;
			margin-top: 20px;
		}

		.btn {
			margin-top: 10px;
			width: 84px;
			height: 32px;
			line-height: 32px;
			background: #FF6A00;
			border-radius: 4px;
			color: #fff;
			font-size: 14px;
			font-weight: 500;
		}
	}

	.middle {
		border-bottom: 1px solid #ccc;
		margin-top: 30px;

		.m-list {
			height: 40px;
			line-height: 40px;

			.item {
				font-size: 16px;
				color: #666666;
				padding: 0 20px;
				cursor: pointer;
			}

			.on {
				color: @color;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					bottom: 0;
					left: 50%;
					width: 80px;
					height: 4px;
					background-color: @color;
					margin-left: -40px;
				}
			}
		}


	}

	.g-body {
		width: 700px;

		.table {
			margin-top: 20px;
		}

		.title {
			color: @color1;
			font-size: 20px;
			font-weight: 600;
			height: 40px;
			line-height: 40px;
			margin-top: 20px;
			text-align: left;

			span {
				font-size: 14px;
				color: #A9A9A9;
				margin-left: 5px;

			}
		}

		#good-body {
			text-align: left;
			padding: 20px 0;

			p {
				margin: 0;
				padding: 0;

				img {
					max-width: 100%;
					width: 700px;
				}
			}

			img {
				max-width: 100%;
				width: 700px;
			}
		}

		.body2 {
			text-align: left;
			margin-top: 30px;

			.item {
				display: flex;
				align-items: center;
				justify-content: space-between;
				border: 1px solid #EBEBEB;
				padding: 10px;
				margin-bottom: 10px;
				border-radius: 4px;

				&:hover {
					border: 1px solid @color;
				}

				.l {
					flex: 1;
					width: 1px;
					margin-right: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					img {

						width: 60px;
						height: 60px;

					}

					.con {
						flex: 1;
						width: 1px;
						margin-left: 10px;

						.t {
							font-size: 14px;
							color: @color1;
							height: 30px;
							line-height: 30px;
						}

						.p {
							font-size: 14px;
							color: #A9A9A9;
							height: 30px;
							line-height: 30px;
						}
					}
				}

				.r {
					width: 110px;
					height: 42px;
					background: @color;
					border-radius: 6px 6px 6px 6px;
					line-height: 42px;
					font-size: 15px;
					color: #fff;
					text-align: center;
				}
			}
		}
	}



	.warp {


		.img-con {
			margin-top: 10px;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;

			.l-img {
				width: 700px;

				.t {
					width: 100%;
					height: 700px;
					position: relative;

					.btn {
						width: 36px;
						height: 36px;
						background: #333;
						border-radius: 30px;
						border: 1px solid #333;
						display: flex;
						align-items: center;
						text-align: center;
						justify-content: center;
						position: absolute;
						top: 50%;
						margin-top: -18px;
						z-index: 99;
						color: #fff;
					}

					.left {
						left: 0;

					}

					.right {
						right: 0;
					}

					img,
					video {
						width: 100%;
						height: 100%;
					}
				}

				.imgs {
					width: 600px;
					height: 120px;
					position: relative;
					margin: 20px auto 0;

					.btn {
						width: 36px;
						height: 36px;
						background: #F5F5F5;
						border-radius: 30px;
						border: 1px solid #D9D9D9;
						display: flex;
						align-items: center;
						text-align: center;
						justify-content: center;
						position: absolute;
						top: 50%;
						margin-top: -18px;
						z-index: 99;
					}

					.left {
						left: -40px;

					}

					.right {
						right: -40px;
					}
				}

				.b {
					width: 100%;
					overflow-x: auto;
					display: flex;
					flex-wrap: nowrap;
					position: relative;
					height: 120px;

					.i {
						min-width: 94px;
						width: 94px;
						height: 94px;
						margin-right: 16px;
						border: 1px solid #D9D9D9;
						border-radius: 6px;
						box-sizing: border-box;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.on {
						border: 1px solid @color;
					}
				}
			}

			.r-con {
				margin-left: 30px;
				flex: 1;
				width: 1px;

				.btns {
					width: 100%;
					line-height: 48px;
					height: 48px;
					display: flex;
					align-items: center;
					border-radius: 10px;
					overflow: hidden;

					.btn {
						flex: 1;
						font-size: 16px;
						font-weight: 600;
						text-align: center;
						color: #fff;
						cursor: pointer;
					}

					.btn1 {
						background: linear-gradient(90deg, #FFBE86 0%, #FF5900 100%);
					}

					.btn2 {
						background: linear-gradient(90deg, #FFCA00 0%, #FF9402 100%);
					}
				}

				.f-list {
					.item {
						display: flex;
						align-items: flex-start;

						.title {
							font-size: 14px;
							color: #7A7A7A;
							width: 70px;
							text-align: justify;

							&:after {
								content: '';
								display: inline-block;
								width: 100%;
								height: 0;
							}
						}
					}

					.slist {
						flex: 1;
						width: 1px;
						margin-left: 20px;
						display: flex;
						align-items: center;
						flex-wrap: wrap;


						.i {
							border: 1px solid #D9D9D9;
							margin: 0 10px 10px 0;
							border-radius: 2px;
							padding: 0 10px;
							font-size: 14px;
							color: #11192D;
							height: 32px;
							line-height: 32px;
						}

						.on {
							border: 1px solid @color;
							color: @color;
						}
					}

					.slist2 {
						flex: 1;
						width: 1px;
						margin-left: 20px;
						display: flex;

						.n {}

						.m {
							margin-left: 20px;
							font-size: 14px;
							color: #7A7A7A;
						}
					}
				}




				.p-s {
					height: 40px;
					line-height: 40px;
					margin: 10px auto;

					.p {
						color: @color;
						font-size: 14px;

						span {
							font-size: 30px;
							font-weight: 600;
							margin-left: 5px;
						}
					}

					.s {
						margin-left: 20px;
						color: #7A7A7A;

						span {
							margin-left: 5px;
						}
					}
				}

				.title {
					text-align: left;
					font-size: 20px;
					color: @color1;
					line-height: 30px;
				}
			}
		}

		.back {
			margin-top: 20px;
			height: 30px;
			line-height: 30px;
			text-align: left;

			span {
				font-size: 16px;
				color: #11192D;
				margin-left: 5px;
			}

			&:hover {
				i {
					color: @color;
				}

				span {
					color: @color;
				}
			}
		}
	}

	.right-float {

		width: 440px;
		height: 750px;
		background: #FFFFFF;
		box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
		border-radius: 10px;
		border: 1px solid #EBEBEB;
		position: fixed;
		top: 100px;
		left: 50%;
		margin-left: 180px;
		padding: 20px;
		box-sizing: border-box;
		z-index: 999;
		overflow-y: auto;

		.img-c {
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			img {
				width: 94px;
				height: 94px;
				border-radius: 6px;
				border: 1px solid #D9D9D9;
			}

			.c {
				margin-top: 30px;
				flex: 1;
				width: 1px;
				margin-left: 10px;
				text-align: left;

				.p {
					font-size: 14px;
					color: @color;

					span {
						font-size: 30px;
						font-weight: 600;
						margin-left: 5px;
					}
				}

				.n {
					color: #7A7A7A;
					font-size: 14px;

					span {
						margin-left: 5px;
					}
				}
			}

		}

		.btns {
			width: 100%;
			line-height: 48px;
			height: 48px;
			display: flex;
			align-items: center;
			border-radius: 10px;
			overflow: hidden;

			.btn {
				flex: 1;
				font-size: 16px;
				font-weight: 600;
				text-align: center;
				color: #fff;
				cursor: pointer;
			}

			.btn1 {
				background: linear-gradient(90deg, #FFBE86 0%, #FF5900 100%);
			}

			.btn2 {
				background: linear-gradient(90deg, #FFCA00 0%, #FF9402 100%);
			}
		}

		.f-list {


			.item {
				display: flex;
				align-items: flex-start;

				.title {
					font-size: 14px;
					color: #7A7A7A;
					width: 70px;
					text-align: justify;

					&:after {
						content: '';
						display: inline-block;
						width: 100%;
						height: 0;
					}
				}
			}

			.slist {
				flex: 1;
				width: 1px;
				margin-left: 20px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;


				.i {
					border: 1px solid #D9D9D9;
					margin: 0 10px 10px 0;
					border-radius: 2px;
					padding: 0 10px;
					font-size: 14px;
					color: #11192D;
					height: 32px;
					line-height: 32px;
				}

				.on {
					border: 1px solid @color;
					color: @color;
				}
			}

			.slist2 {
				flex: 1;
				width: 1px;
				margin-left: 20px;
				display: flex;

				.n {}

				.m {
					margin-left: 20px;
					font-size: 14px;
					color: #7A7A7A;
				}
			}
		}

		.p-s {
			height: 40px;
			line-height: 40px;

			.p {
				color: @color;
				font-size: 14px;

				span {
					font-size: 30px;
					font-weight: 600;
					margin-left: 5px;
				}
			}

			.s {
				margin-left: 20px;
				color: #7A7A7A;

				span {
					margin-left: 5px;
				}
			}
		}

		.title {
			text-align: left;
			font-size: 20px;
			color: @color1;
			line-height: 30px;
		}
	}

	.not {
		.slist {
			.on {
				border: 1px solid #eee !important;
				background-color: #F5F5F5 !important;
				color: #ccc !important;
			}
		}
	}
</style>